module.exports = __webpack_public_path__ + "static/media/6.4f655445.png";